// extracted by mini-css-extract-plugin
module.exports = {"title":"listingsPageTitle_title__74oYq","titleAr":"listingsPageTitle_titleAr__vS29e","countAr":"listingsPageTitle_countAr__BnLvi"};